export const requiredStepsNum = [
  { label: "3 steps", value: "3" },
  { label: "5 steps", value: "5" },
  { label: "10 steps", value: "10" },
  { label: "Custom", value: "custom" },
];
